import request from '@/utils/request'

export function getTaskCfgList(data) {
  return request({
    url: 'api/v1/task/getTaskCfg',
    method: 'get',
    params: data
  })
}

export function updateTaskCfg(data) {
  return request({
    url: 'api/v1/task/updateTaskCfg',
    method: 'post',
    data: data
  }
  )
}

export function importTaskCfg(data) {
  return request({
    url: 'api/v1/task/import',
    method: 'post',
    data: data
  }
  )
}

export function exportTaskCfg(data) {
  return request({
    url: 'api/v1/task/export',
    method: 'post',
    data: data
  }
  )
}
